import React from "react"
import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {useTheme} from "@mui/material/styles";
import {getFocusBackgroundColor} from "../../utility/windowUtil";
import {metaDataProperty} from "../preview/previewMetaData";
import {usePreviewContext} from "../../context/PreviewContext";
import PreviewElementBoxDrawer from "../preview/PreviewElementBoxDrawer";

interface Props {
    id?: string,
    title: string,
    propertyName?: string,
    expanded?: boolean,
    initiallyExpanded?: boolean,
    onChange?: any,
    children?: JSX.Element
    sx?: any
    typoSx?: any
    dataCypress?: string
}

function CCOAccordion(props: Props) {
    const theme = useTheme();
    const isPreview = usePreviewContext().isPreview;
    const AccordionSummaryStyle = {
        fontFamily: theme.typography.accordion.fontFamily,
        padding: 0,
        color: props.expanded ? theme.palette.primary.main : theme.palette.text.primary,
        '&:hover': {
            color: theme.palette.primary.main,
            '& .MuiAccordionSummary-expandIconWrapper': {
                color: theme.palette.primary.main,
            }
        },

    }
    const AccordionDetailsStyle = {
        padding: '4px 0 8px 0',
    }
    const AccordionStyle = {
        ...props.sx,
        my: 0,
        width: "100%",
        '& .MuiAccordionSummary-root:focus-visible, & .MuiAccordionSummary-root:focus-visible + .MuiCollapse-root': {
            backgroundColor: getFocusBackgroundColor(theme) + '!important',
        }
    };
    const TypoStyle = {
        ...props.typoSx,
    }
    return <PreviewElementBoxDrawer propertyId={props.id}>
        <Accordion data-cypress={props.dataCypress || 'accordionItem'}
            disableGutters={true}
            expanded={props.expanded}
            defaultExpanded={props.initiallyExpanded}
            onChange={props.onChange}
            sx={AccordionStyle}>
            <AccordionSummary
                sx={AccordionSummaryStyle}
                id={props.id}
                expandIcon={<ExpandMoreIcon/>}
            >
                <Typography sx={TypoStyle} variant={"accordion"} {...metaDataProperty(isPreview, props.propertyName, props.id)}>{props.title}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={AccordionDetailsStyle}>
                {props.children}
            </AccordionDetails>
        </Accordion>
    </PreviewElementBoxDrawer>
}


export default CCOAccordion